import { Component, computed, ElementRef, viewChildren } from '@angular/core';
import { PropsServiceService } from '../../props-service.service';
import { KopConfigService } from '../../../core/kop-config.service';
import { AnalogOut, ModuleServo } from '../../PropTypes';
import { JSBridgeService } from '../../../core/jsbridge.service';
import { KanaalService } from '../../../kanaal/kanaal.service';
import { wasmVectorToArray } from '../../../utils/wasmVector';
import { kanaalLabelHdw, rangedKanaalLabel } from '../../../kanaal/kanaal.utils';
import { BaseListComponent } from '../../../keynav/base-list/base-list.component';
import { FocusManagerService } from '../../../keynav/focus-manager.service';
import { BaseElementComponent } from '../../../keynav/base-element/base-element.component';
import { LosDefEditorComponent } from '../../los-def-editor/los-def-editor.component';
import { ServoEditorComponent } from '../../servo-editor/servo-editor.component';

@Component({
  selector: 'klassiek-servo',
  templateUrl: './klassiek-servo.component.html',
  styleUrl: './klassiek-servo.component.scss',
  providers: [
    {
      provide: 'i18n-label',
      useValue: 'KlassiekServoComponent'
    }
  ]

})
export class KlassiekServoComponent extends BaseListComponent {

  constructor(public propsService: PropsServiceService, public kopConfigService: KopConfigService,
    public jsBridgeService: JSBridgeService, private kanaalService: KanaalService, elementRef: ElementRef<HTMLElement>, focusManager: FocusManagerService) {
    super(elementRef, focusManager);
    this.keyProperty = "klassiek-servo";
  }


  public availableServos = computed(() => {
    let currentServos = this.propsService.servos();
    let servosMetas = this.kopConfigService.currentMeta().servos;
    let metas = servosMetas.sort((s1, s2) => s1.prio - s2.prio).filter(servo => !currentServos.find(s => s.index == servo.index));
    let ret = metas.map(m => {
      return this.kopConfigService.servoKCtoModule(m.index, undefined);
    });
    return ret;

  });


  public servoEditors = viewChildren(ServoEditorComponent);
  public getChildren(): readonly BaseElementComponent[] {
    return this.servoEditors();
  }

}
